import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Icons from "../Icons";
import ScanIcon from "../../assests/images/scanIcon.svg";
import MarlboroRed from "../../assests/images/marlboro_red.svg";
import marlboroGold from "../../assests/images/marlboro_gold.svg";
import MarlboroGoldAdvance from "../../assests/images/marlboro-gold-advance.svg";
import marlboroFuseBeyond from "../../assests/images/marlboro-fuse-beyond.svg";
import MarlborocloveMix from "../../assests/images/marlboro-clove-mix.svg";
import MarlboroVistaForestFusion from "../../assests/images/marlboro-vista-forest-fusion.svg";
import starbig from "../../assests/images/starbig.svg";
import alertimg from "../../assests/images/alertimg.svg";
import MonthlyFilter from "./MonthlyFilter";
import { translation_en } from "../../translations/translation_en";
import { translation_hi } from "../../translations/translation_hi";
import i18n from "../../i18n";

const variantImages: Record<string, string> = {
  "Marlboro Red": MarlboroRed,
  "Marlboro Gold": marlboroGold,
  "Marlboro Gold Advance": MarlboroGoldAdvance,
  "Marlboro Fuse Beyond": marlboroFuseBeyond,
  "Marlboro Clove Mix": MarlborocloveMix,
  "Marlboro Vista Forest Fusion": MarlboroVistaForestFusion,
};

type Props = {
  token?: string;
  accountId?: string;
  initialMonthlyItem?: any;
  monthlyPayload?: any;
  month?: string | undefined;
  year?: number | undefined;
  setMonth?: (m?: string) => void;
  setYear?: (y?: number) => void;
  taskTitle?: string;
};

const MonthTarget: React.FC<Props> = ({
  token = "",
  accountId = "",
  initialMonthlyItem = {},
  monthlyPayload = null,
  month,
  year,
  setMonth,
  setYear,
  taskTitle,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isSmallMobile = useMediaQuery("(max-width:380px)");
  const [openFilter, setOpenFilter] = useState(false);
  const handleOpenFilter = () => setOpenFilter(true);
  const langKey = (
    localStorage.getItem("LANGUAGELOCALEKEY") ||
    i18n.language ||
    "en_IN"
  ).toString();
  const translations = langKey.startsWith("hi")
    ? translation_hi
    : translation_en;
  const [variants, setVariants] = useState<any[]>(
    initialMonthlyItem?.List_of_variants ?? []
  );
  const [delayDays, setDelayDays] = useState<any>(
    initialMonthlyItem?.days_left_in_target_month ?? ""
  );
  const [totalValue, setTotalValue] = useState<string>(
    initialMonthlyItem?.["total_actual_points/total_target_points"] ?? ""
  );
  const [availableMonths, setAvailableMonths] = useState<string[]>(
    initialMonthlyItem?.month_filter ?? []
  );
  const [availableYears, setAvailableYears] = useState<number[]>(
    initialMonthlyItem?.year_filter ?? []
  );
  const [selectedMonth, setSelectedMonth] = useState<string>(
    initialMonthlyItem?.month ??
      initialMonthlyItem?.month_filter?.slice(-1)?.[0] ??
      ""
  );
  const [selectedYear, setSelectedYear] = useState<number>(
    initialMonthlyItem?.year ??
      initialMonthlyItem?.year_filter?.slice(-1)?.[0] ??
      new Date().getFullYear()
  );
const dotCodeScanning = (translations as any)?.taskdetaitls?.dot_code_scanning || {};

// labels 
const scandata = dotCodeScanning.scan_earn ?? "Scan & Earn";
const monthtarget = dotCodeScanning.month_target ?? "Monthly Target";
const listofVarinats = dotCodeScanning.list_of_variants ?? "List of Variants";
const pointsEarned = dotCodeScanning.points_earned_month ?? "Points Earned";
const days_left = dotCodeScanning.days_left_month ?? "";

  const [packcount, setPackcount] = useState<number>(
    Number(initialMonthlyItem?.packcount) || 0
  );

  useEffect(() => {
    if (!initialMonthlyItem) return;
    setVariants(initialMonthlyItem?.List_of_variants ?? []);
    setDelayDays(initialMonthlyItem?.days_left_in_target_month ?? "");
    setTotalValue(
      initialMonthlyItem?.["total_actual_points/total_target_points"] ?? ""
    );
    setAvailableMonths(initialMonthlyItem?.month_filter ?? []);
    setAvailableYears(initialMonthlyItem?.year_filter ?? []);
    setSelectedMonth(
      initialMonthlyItem?.month ??
        initialMonthlyItem?.month_filter?.slice(-1)?.[0] ??
        ""
    );
    setSelectedYear(
      initialMonthlyItem?.year ??
        initialMonthlyItem?.year_filter?.slice(-1)?.[0] ??
        new Date().getFullYear()
    );
    setPackcount(
      initialMonthlyItem?.packcount !== undefined &&
        initialMonthlyItem?.packcount !== null
        ? Number(initialMonthlyItem.packcount) || 0
        : 0
    );
  }, [initialMonthlyItem]);

  // When user picks month/year, update local selected values and ask TaskDetails to refetch via setMonth/setYear
  const handleMonthSelect = async (m: string) => {
    setSelectedMonth(m);
    if (setMonth) setMonth(m);
  };

  const handleYearSelect = async (y: number) => {
    setSelectedYear(y);
    if (setYear) setYear(y);
  };

  const totalCurrent = variants.reduce(
    (sum, v) => sum + (v.total_sticks || 0),
    0
  );
  const totalMax = variants.reduce(
    (sum, v) => sum + (v.variant_max_vol || 0),
    0
  );
  const progressPercent = totalMax ? (totalCurrent / totalMax) * 100 : 0;
  console.log(progressPercent);

  return (
    <Box
      sx={{
        p: isMobile ? 1 : 2,
        background: "linear-gradient(to top, #FFF8BB 0%, #ffffff 100%)",
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          fontWeight={600}
          fontFamily={"Inter"}
          sx={{
            textAlign: "left",
            fontSize: isSmallMobile ? "16px" : "inherit",
            flexShrink: 0,
            mr: 1,
            ml: 2,
          }}
        >
          {monthtarget}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            borderRadius: "10px",
            px: isSmallMobile ? 0.5 : 1,
            py: 0.3,
            gap: 0.5,
            background: "#fff",
            cursor: "pointer",
            flexShrink: 0,
            minWidth: "fit-content",
          }}
          onClick={handleOpenFilter}
        >
          <MonthlyFilter
            selectedMonth={selectedMonth}
            setSelectedMonth={(m: string) => handleMonthSelect(m)}
            selectedYear={selectedYear}
            setSelectedYear={(y: number) => handleYearSelect(y)}
            availableMonths={availableMonths}
            availableYears={availableYears}
          />
        </Box>
      </Box>

      <Card
        sx={{
          mt: 2,
          borderRadius: "16px",
          boxShadow: "none",
          overflow: "visible",
        }}
      >
        <CardContent
          sx={{
            padding: isSmallMobile ? "12px" : "16px",
            "&:last-child": { pb: isSmallMobile ? "12px" : "16px" },
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{ flexWrap: "nowrap" }}
          >
            <Box
              display="flex"
              alignItems="center"
              gap={isSmallMobile ? 1 : 1.2}
              sx={{ flexShrink: 0 }}
            >
              <img src={ScanIcon} alt="scan Icon" />
              <Box>
                <Typography
                  fontSize={isSmallMobile ? 11 : 13}
                  color="#757575"
                  sx={{ textAlign: "left" }}
                >
                  {taskTitle ||
                    initialMonthlyItem?.task_title ||
                    "Monthly Task"}
                </Typography>
                <Typography
                  fontWeight={600}
                  fontSize={isSmallMobile ? 13 : "inherit"}
                  textAlign={"left"}
                >
                  {scandata}
                </Typography>
              </Box>
            </Box>

            <Chip
              icon={<Icons name="timerImage" />}
              label={`${delayDays} ${days_left}`}
              size="small"
              sx={{
                bgcolor: "#f5f5f5",
                color: "#000",
                fontWeight: 500,
                borderRadius: "8px",
                fontSize: isSmallMobile ? 11 : "inherit",
                height: isSmallMobile ? 28 : 32,
                flexShrink: 0,
                ml: 1,
              }}
            />
          </Box>

          <Box
            mt={2}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "nowrap",
            }}
          >
            <Typography
              fontSize={isSmallMobile ? 11 : 13}
              sx={{
                paddingTop: "10px",
                color: "#282829",
                fontWeight: "500",
                flexShrink: 0,
                mr: 1,
              }}
            >
              {pointsEarned}
            </Typography>

            {(() => {
              const [earned, target] = totalValue?.split("/")?.map(Number) || [
                0, 0,
              ];
              const percent = target ? (earned / target) * 100 : 0;

              let color = "#E53935";
              if (percent > 0 && percent < 100) color = "#FB8C00";
              if (percent >= 100) color = "#43A047";

              return (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                    background:
                      "linear-gradient(180deg, #FFF4E5 0%, #FFF4E5 100%)",
                    borderRadius: "12px",
                    px: isSmallMobile ? 1 : 2,
                    py: isSmallMobile ? 0.5 : 1,
                    position: "relative",
                    width: "fit-content",
                    overflow: "hidden",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: "10%",
                      right: 0,
                      height: "2px",
                      background:
                        "linear-gradient(to right, #fff5ee 0%, #ff9800 50%, #fff5ee 100%)",
                      width: "80%",
                      borderTopLeftRadius: "12px",
                      borderTopRightRadius: "12px",
                    },
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      bottom: 0,
                      left: "10%",
                      right: 0,
                      height: "2px",
                      background:
                        "linear-gradient(to right, #fff5ee 0%, #ff9800 50%, #fff5ee 100%)",
                      width: "80%",
                      borderBottomLeftRadius: "12px",
                      borderBottomRightRadius: "12px",
                    },
                  }}
                >
                  <Typography
                    fontWeight={600}
                    display="flex"
                    alignItems="center"
                    sx={{
                      zIndex: 1,
                      fontSize: isSmallMobile ? 12 : "inherit",
                    }}
                  >
                    <Box component="span" sx={{ color: color }}>
                      {earned || 0}
                    </Box>
                    <Box component="span" sx={{ color: "#000" }}>
                      /{target || 0}
                    </Box>
                  </Typography>

                  <Box sx={{ zIndex: 1, lineHeight: 0 }}>
                    <Icons
                      width={isSmallMobile ? 18 : 22}
                      height={isSmallMobile ? 18 : 22}
                      name={"goldCoin"}
                    />
                  </Box>
                </Box>
              );
            })()}
          </Box>
          <Box mt={1.5}>
            {(() => {
              const [earned, target] = totalValue?.split("/")?.map(Number) || [
                0, 0,
              ];
              const percent = target ? (earned / target) * 100 : 0;

              // let progressColor = "#C8172F";
              // if (percent > 0 && percent < 100) progressColor = "#FF933A ";
              // if (percent >= 100) progressColor = "#4CAF50";
              const progressColor = "#4CAF50"; // Constant color for all progress bars

              return (
                <LinearProgress
                  variant="determinate"
                  value={percent > 100 ? 100 : percent}
                  sx={{
                    height: 4,
                    borderRadius: 5,
                    backgroundColor: "#E0E0E0",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: progressColor,
                    },
                  }}
                />
              );
            })()}
          </Box>

          {/* Notification box: show ONLY when packcount > 0 */}
          {packcount > 0 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: isSmallMobile ? 1 : 2,
                background: "linear-gradient(180deg, #FFE9E2 0%, #FFE9E2 100%)",
                borderRadius: "16px",
                p: isSmallMobile ? 1.5 : 2,
                width: "100%",
                maxWidth: 420,
                boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                position: "relative",
                mt: "10px",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: "13%",
                  right: 0,
                  height: "2px",
                  background:
                    "linear-gradient(to right, #fff5ee 0%, #ff9800 50%, #fff5ee 100%)",
                  borderTopLeftRadius: "16px",
                  borderTopRightRadius: "16px",
                  width: "70%",
                },
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: 0,
                  left: "13%",
                  right: 0,
                  height: "2px",
                  background:
                    "linear-gradient(to right, #fff5ee 0%, #ff9800 50%, #fff5ee 100%)",
                  borderTopLeftRadius: "16px",
                  borderTopRightRadius: "16px",
                  width: "70%",
                },
              }}
            >
              {/* Icon Circle */}
              <Box
                sx={{
                  width: isSmallMobile ? 40 : 48,
                  height: isSmallMobile ? 40 : 48,
                  borderRadius: "50%",
                  backgroundColor: "#FFDED5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: "-11px",
                    left: "16px",
                    width: "11px",
                    height: "11px",
                    borderRadius: "50%",
                    backgroundImage: `url(${starbig})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    opacity: 1,
                    zIndex: 0,
                  },
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundImage: `url(${starbig})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    opacity: 1,
                    zIndex: 0,
                  },
                }}
              >
                <img
                  src={alertimg}
                  alt="alert"
                  style={{ width: isSmallMobile ? 20 : 24 }}
                />
              </Box>

              {/* Text Block */}
              <Box>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: isSmallMobile ? "12px" : "14px",
                    color: "#222",
                  }}
                >
                  {`Total of Pending Scan is ${packcount} `}
                </Typography>
              </Box>
            </Box>
          )}
        </CardContent>
      </Card>

      <Box mt={3}>
        <Typography
          fontWeight={600}
          ml={2}
          mb={1}
          textAlign={"left"}
          fontSize={isSmallMobile ? 14 : "inherit"}
        >
          {listofVarinats}
        </Typography>

        {variants.map((v, i) => {
          // --- Decide if variant has a finite max (original flow) ---
          const variantMaxVol = Number(v.variant_max_vol || 0);
          const hasMax = variantMaxVol > 0 && isFinite(variantMaxVol);
          console.log(hasMax);
          // canonical: base = B, bonus increment = BI, C = B + BI
          const B = Number(v.base_target || 0);
          // prefer explicit bonus_increment; fallback to older bonus_target (absolute) by subtracting base
          const rawBonusTarget = Number(v.bonus_target ?? 0);
          let BI = 0;
if (v.bonus_increment !== undefined && v.bonus_increment !== null) {
  BI = Number(v.bonus_increment) || 0;
} else if (rawBonusTarget > B) {
  BI = rawBonusTarget - B;
} else {
  BI = 0;
}
const hasBonus = BI > 0;
          const C = hasBonus ? B + BI : 0;
            const basePoints = Number(v.base_points || 0);            // value shown above base marker (coin)
            const bonusPoints = Number(v.bonus_points || 0);          // bonus points value
            const topBaseLabel = basePoints;                          // above base marker
            const topBonusLabel = bonusPoints;    
          // --- Fixed-percentage model (when variant_max_vol is not available/finite) ---
          const BASE_PCT = 40; // base = 50%
          const BONUS_PCT = 40; // bonus = 40%
          const OVER_PCT = 20; // overachiever = 10%

          const clamp = (x: number, min = 0, max = 100) =>
            Math.min(max, Math.max(min, x));

          // compute marker positions for base/bonus (these are "marker" positions where dots/labels appear)
          let stickPercent = B > 0 ? BASE_PCT : 0;
          let targetPercent = hasBonus ? BASE_PCT + BONUS_PCT : stickPercent;
          let totalSticksPercent = 0;
          let goldenSegmentPercent = 0; // gold overlay (progress after base)

          const total = Number(v.total_sticks || 0);

          // No finite max: map absolute stick counts into fixed percentage buckets based on B and BI
          // Using fixed-percentage model (BASE_PCT / BONUS_PCT / OVER_PCT)
          const base = Math.max(B, 1); // avoid div-by-zero
          const bonus = Math.max(BI, 1); // at least 1

          if (!hasBonus) {
  // pure-base mode: green up to BASE_PCT for the base,
  // then golden grows for any sticks beyond base (mapped into BONUS_PCT + OVER_PCT)
  if (total <= base) {
    // still inside base
    totalSticksPercent = (total / base) * BASE_PCT;
    goldenSegmentPercent = 0;
  } else {
    // reached base: fill BASE_PCT and map overflow into (BONUS_PCT + OVER_PCT)
    const beyond = total - base;
    const combinedBonus = BONUS_PCT + OVER_PCT;
    // map beyond relative to base size (adjust denominator if you want slower/faster growth)
    const mappedBeyond = Math.min(
      combinedBonus,
      (beyond / Math.max(base, 1)) * combinedBonus
    );

    totalSticksPercent = BASE_PCT + mappedBeyond;
    goldenSegmentPercent = mappedBeyond;
  }
} else {
  if (total <= base) {
    totalSticksPercent = (total / base) * BASE_PCT;
    goldenSegmentPercent = 0;
  } else if (total <= base + bonus) {
    totalSticksPercent = BASE_PCT + ((total - base) / bonus) * BONUS_PCT;
    goldenSegmentPercent = ((total - base) / bonus) * BONUS_PCT;
  } else {
    const overAmount = total - base - bonus;
    const overMapped = Math.min(OVER_PCT, (overAmount / Math.max(bonus, 1)) * OVER_PCT);
    totalSticksPercent = BASE_PCT + BONUS_PCT + overMapped;
    goldenSegmentPercent = BONUS_PCT + overMapped;
  }
}

          // clamp computed marker positions
          const safeStickMarker = clamp(stickPercent);
          const safeTargetMarker = clamp(targetPercent);
          const safeTotalFill = clamp(totalSticksPercent);
          const safeGoldenWidth = clamp(goldenSegmentPercent);
          const isPureBonusMode = B <= 0; // no base target
        //   const variantImage = variantImages[v.name];

        const resolvedImage = (v?.img_path && String(v.img_path).trim()) 
            ? String(v.img_path).trim()
            : (variantImages[v.name] ? variantImages[v.name] : null);



          // offsets to avoid overlap (existing logic)
          let stickOffset = 0;
          let targetOffset = 0;
          let stickBottomOffset = 0;
          let targetBottomOffset = 0;
          if (hasBonus && Math.abs(safeStickMarker - safeTargetMarker) < 8) {
            // stickOffset = isSmallMobile ? -15 : -25;
            targetOffset = isSmallMobile ? 12 : 20;
            targetBottomOffset = isSmallMobile ? 12 : 20;
            // targetBottomOffset = isSmallMobile ? 15 : 25;
          }

          const overflow = Math.max(0, total - C);

          return (
            <Card
              key={i}
              sx={{
                mb: 2,
                borderRadius: "15px",
                boxShadow: "0",
              }}
            >
              <CardContent sx={{ position: "relative", pb: "20px !important" }}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ flexWrap: "nowrap" }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={isSmallMobile ? 1 : 1.5}
                    sx={{ minWidth: 0 }}
                  >
                    {resolvedImage ? (
  <img
    src={resolvedImage}
    alt={v.name || "variant image"}
    style={{
      width: isSmallMobile ? 60 : 70,
      height: isSmallMobile ? 30 : 30,
      objectFit: "contain",
      borderRadius: "4px",
      flexShrink: 0,
    }}
  />
) : (
  <Box
    sx={{
      width: isSmallMobile ? 60 : 70,
      height: isSmallMobile ? 30 : 30,
      borderRadius: "4px",
      flexShrink: 0,
    }}
  />
)}

                    <Typography
                      fontWeight={900}
                      sx={{
                        textAlign: "left",
                        fontSize: isSmallMobile ? 12 : 13,
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "normal",
                        flex: 1,
                      }}
                    >
                      {v.name}
                    </Typography>
                  </Box>
                  <Box sx={{ flexShrink: 0, ml: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        background: "#FBF3E0",
                        border: "1px solid #F9E3B6",
                        borderRadius: "30px",
                        padding: isSmallMobile ? "1px 6px" : "2px 10px",
                      }}
                    >
                      <Icons
                        width={isSmallMobile ? 14 : 18}
                        height={isSmallMobile ? 14 : 18}
                        name={"goldCoin"}
                      />
                      <Typography
                        sx={{
                          whiteSpace: "nowrap",
                          fontSize: isSmallMobile ? 11 : "inherit",
                        }}
                      >
                        {v.points} pts
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box position="relative" mt={isSmallMobile ? 5 : 6}>
                  <Box
                    sx={{
                      width: "100%",
                      height: 4,
                      borderRadius: 5,
                      backgroundColor: "#E0E0E0",
                      position: "relative",
                    }}
                  >
                    {/* main green fill (total achieved) */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: `${safeTotalFill}%`,
                        backgroundColor: isPureBonusMode ? "transparent" : "#4CAF50",
                        borderRadius: 5,
                        transition: "width 0.4s ease",
                      }}
                    />

                    {/* golden overlay representing "progress after base" */}
                    {/* Yellow segment: Base -> Bonus */}
<Box
  sx={{
    position: "absolute",
    top: 0,
    left: `${safeStickMarker}%`,
    height: "100%",
    width: `${Math.min(goldenSegmentPercent, BONUS_PCT)}%`,
    background:
      "linear-gradient(90deg, #DFA530 0%, #FFD54F 100%)",
    borderRadius: goldenSegmentPercent > BONUS_PCT? "5px 0 0 5px": 5,
    transition: "width 0.4s ease",
  }}
/>

{/* Red segment: Beyond Bonus */}
{goldenSegmentPercent > BONUS_PCT && (
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: `${safeStickMarker + BONUS_PCT}%`,
      height: "100%",
      width: `${goldenSegmentPercent - BONUS_PCT}%`,
      background: "#E53935",
      borderRadius: "0 5px 5px 0",
      transition: "width 0.4s ease",
    }}
  />
)}
                    {/* overflow badge when over bonus */}
                    {/* {overflow > 0 && (
                      <Box
                        sx={{
                          position: "absolute",
                          right: 0,
                          top: -20,
                          background: "#FFE0B2",
                          px: 1,
                          py: 0.3,
                          borderRadius: 8,
                          boxShadow: "0 1px 6px rgba(0,0,0,0.12)",
                          fontSize: isSmallMobile ? 11 : 12,
                        }}
                      >
                        +{overflow} over
                      </Box>
                    )} */}
                  </Box>

                  {/* Base marker (dot + label) */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 9,
                      left: `${safeStickMarker}%`,
                      transform: `translate(calc(-50% + ${stickOffset}px), -100%)`,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    {B > 0 && (
                      <Box
                        sx={{
                          background: "#F5F6F7",
                          px: isSmallMobile ? 0.5 : 0.8,
                          py: 0.2,
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          gap: 0.4,
                          mb: 0.4,
                        }}
                      >
                        <Typography
                          fontSize={isSmallMobile ? 12 : 16}
                          fontWeight={600}
                        >
                           {topBaseLabel}
                        </Typography>
                        <Icons
                          width={isSmallMobile ? 14 : 18}
                          height={isSmallMobile ? 14 : 18}
                          name={"goldCoin"}
                        />
                      </Box>
                    )}
                    <Box
                      sx={{
                        width: isSmallMobile ? 12 : 16,
                        height: isSmallMobile ? 12 : 16,
                        borderRadius: "50%",
                        background: "#4CAF50",
                        border: "2px solid #FFF",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
                      }}
                    />
                  </Box>

                  {/* Bonus marker (dot + label) */}
                  {hasBonus && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: 9,
                      left: `${safeTargetMarker}%`,
                      transform: `translate(calc(-50% + ${targetOffset}px), -100%)`,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        background: "#F5F6F7",
                        px: isSmallMobile ? 0.5 : 0.8,
                        py: 0.2,
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.4,
                        mb: 0.4,
                      }}
                    >
                      <Typography
                        fontSize={isSmallMobile ? 12 : 16}
                        fontWeight={600}
                      >
                         {topBonusLabel}
                      </Typography>
                      <Icons
                        width={isSmallMobile ? 14 : 18}
                        height={isSmallMobile ? 14 : 18}
                        name={"goldCoin"}
                      />
                    </Box>
                    <Box
                      sx={{
                        width: isSmallMobile ? 12 : 16,
                        height: isSmallMobile ? 12 : 16,
                        borderRadius: "50%",
                        background:
                          "linear-gradient(90deg, #DFA530 0%, #FFD54F 100%)",
                        border: "2px solid #FFF",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
                      }}
                    />
                  </Box>
                  )}
                </Box>

                <Box position="relative" mt={1} sx={{ height: 30 }}>
                  {B > 0 && (
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        left: `${safeStickMarker}%`,
                        transform: `translate(calc(-50% + ${stickBottomOffset}px), 0)`,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        transition: "left 0.4s ease",
                      }}
                    >
                      <Typography
                        fontSize={isSmallMobile ? 11 : 14}
                        color="#000"
                        fontWeight={500}
                      >
                        {B} Sticks
                      </Typography>
                    </Box>
                  )}
                  {hasBonus && (
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: `${safeTargetMarker}%`,
                      transform: `translate(calc(-50% + ${targetBottomOffset}px), 0)`,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      transition: "left 0.4s ease",
                    }}
                  >
                    <Typography
                      fontSize={isSmallMobile ? 11 : 14}
                      color="#000"
                      fontWeight={500}
                    >
                      {C} Sticks
                    </Typography>
                  </Box>
                  )}
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </Box>
    </Box>
  );
};

export default MonthTarget;
